import { render, staticRenderFns } from "./HistoryRewardAdHoc.vue?vue&type=template&id=56d7da98"
import script from "./HistoryRewardAdHoc.vue?vue&type=script&lang=js"
export * from "./HistoryRewardAdHoc.vue?vue&type=script&lang=js"
import style0 from "./HistoryRewardAdHoc.vue?vue&type=style&index=0&id=56d7da98&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports